import {
  CODIGOS_POSTALES_COMPLETED,
  CODIGOS_POSTALES_FAILED,
  CODIGOS_POSTALES_INITED
} from "./actions";

const initialState = {
  isLoading: false,
  codigosPostales: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CODIGOS_POSTALES_INITED:
      return {
        ...state,
        codigosPostales: [],
        isLoading: true
      };
    case CODIGOS_POSTALES_FAILED:
      return {
        ...state,
        codigosPostales: [],
        isLoading: false
      };
    case CODIGOS_POSTALES_COMPLETED:
      return {
        ...state,
        codigosPostales: [...action.payload.codigosPostales],
        isLoading: false
      };
    default:
      return state;
  }
};

export default reducer;
